<template>
    <a-card type="inner" size="small">
        <a-table
            class="pcp-table"
            :dataSource="items.material_exams"
            :loading="loading"
            rowKey="id"
            :pagination="false"
        >

            <a-table-column key="description" title="Keterangan" className="align-center text-small text-left">
                <template slot-scope="record">
                    <a :href="routeUri('admin.classical.material.exam.questions', { exam: record.id })">
                        {{ record.description }}
                    </a>
                </template>
            </a-table-column>

            <a-table-column key="created_at" title="Dibuat pada" className="align-center text-small text-left">
                <template slot-scope="record">
                     {{ moment(record.created_at).format('DD-MM-YYYY HH:mm:ss') }}
                </template>
            </a-table-column>
        </a-table>

        <a-row type="flex" justify="center" style="margin-top: 12px">
            <a-col>
                <a-space>
                    <a-button
                        @click="handleClose"
                        :loading="processing"
                        :disabled="processing"
                        >Tutup</a-button>
                </a-space>
            </a-col>
        </a-row>

    </a-card>
</template>

<script>
export default {
    props: {
        material_id: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            loading: false,
            visible: false,
            processing: false,
            items: {},
        }
    },
    created() {
        this.getItems()
    },
    methods: {
        getItems() {
            this.loading = true

            this.$http
                .get(this.routeUri('api.material-exam', { material: this.material_id }))
                .then(response => (this.items = response.data))
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        handleSuccessResponse(data) {
            let successMessage = "Data berhasil diproses!"

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            })

            this.getItems()
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    })
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                })
            }
        },
        handleClose() {
            this.$emit("handleClose", false)
        }
    }
}
</script>
